/**
 * useAppIntro composable
 *
 * Decides whether the Coridor entry animation should play this session.
 * Uses sessionStorage (not localStorage) specifically because of how it
 * behaves across a full app/page reload vs a background/foreground toggle:
 *
 * - Native (Android/iOS WebView): backgrounding the app without the OS
 *   killing the process keeps the same WebView instance alive, so
 *   sessionStorage survives and the intro does not replay. If the app is
 *   fully closed/killed and relaunched, the WebView is recreated from
 *   scratch — a brand new session — so the intro plays again. This gives
 *   "shows every time the app is closed and reopened" with no native
 *   code changes needed.
 * - Web: shows once per tab/browser session. Reloading the same tab (F5)
 *   does not replay it; opening a new tab or reopening the browser does.
 */

const STORAGE_KEY = 'coridor_intro_shown'

export function shouldShowAppIntro() {
  try {
    return !sessionStorage.getItem(STORAGE_KEY)
  } catch (e) {
    // sessionStorage unavailable (private mode, quota, etc.) — don't block the app on it.
    return false
  }
}

export function recordAppIntroVisit() {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1')
  } catch (e) {
    // Ignore — worst case the intro shows slightly more often.
  }
}
